import { i18nMark } from 'lingui-react';

const messages = {
  title: i18nMark('{serviceRequestId}'),
  codeDescription: i18nMark('Code - Description'),
  reasonForRepair: i18nMark('Reason for Repair'),
  requested: i18nMark('Requested'),
  serviceProvider: i18nMark('Service Provider'),
  status: i18nMark('Status'),
  complaint: i18nMark('Complaint'),
  vin: i18nMark('VIN'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/ServiceRequestDisplayElement/messages.js